import React from 'react';

const Section2 = ({ entry }) => (
  <div className="col-xs-4">
    <div className="bold">{entry.title}</div>
    <div>{entry.contactName}</div>
    <div>{entry.streetAddress1}</div>
    <div>{entry.streetAddress2}</div>
    <div>
      <span>{entry.city}, </span>
      <span>{entry.state} </span>
      <span>{entry.zipCode}</span>
    </div>
  </div>
);

export default Section2;
